import React, { Component } from 'react';
import $ from 'jquery';
import '../css/dataTables.css';
import {renderTableName,renderColumnsName} from "./index";
import {QueryPreviewModal} from "../components";
import { QueryModel } from './NewOrder';
import {ApiClient} from "../libs/apiClient";
let headers = [
    {title: 'Tabla'}
];
let headers2 = [
    {title: 'Nombre de columna'}
];

let apiClient = ApiClient.getInstance();
class CreateQueryModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            tablas: [],
            propSelected:[],
            columName: [],
            checklist:[],
            SLECT:'',
            FROM:'',
            idCheck:0,
            checkboxDataTables: (new Map()),
            queryModel:{}
        };
        this.newModelCopy = '';
    }

    componentDidMount = async () =>{
       let queryModel= new QueryModel();
       this.setState({
            queryModel
       });
    }

    closeQuery= async () => {
        $('#queryModal').modal('hide');
    };

    ShowPreview = () => {
        $('#queryPreview').modal({backdrop: 'static', keyboard: false}, 'show');
    };
    
    refreshModel = queryModel => {
        this.setState({
            queryModel
        });
    };

    toggleDocumentSelected = (id) => {
        const {queryModel}=this.state;
        queryModel.idCheck=id;
        this.setState(state => {
            const checkboxDataTables = (new Map());
            checkboxDataTables.set(id, !checkboxDataTables.get(id));// toggle
            return {checkboxDataTables};
        });
      this.refreshModel(queryModel);  
    };

    columnSelected = (table,id) => {
        const  {tablas,queryModel,columName,SELECT,FROM} = this.state;
        let columnId=columName[table];
       
        let tableName=tablas[table].nombre
        let select=SELECT || '';
        let from=FROM || `FROM [${tableName}]`;
       
        
        columnId.map((column, index) => {
            if(index===id){
                select+=`T${table}.${column.ColumnName}, `||'';
            }           
        });
        // //console.log("",`FROM [${tableName}]`,`${from}`);
        if(`FROM [${tableName}]` !== `${from}`){
            from+=`INNER JOIN [${tableName}]`;
        }

        queryModel.query='';
        
        this.setState({
            SELECT:select,
            FROM:from

        });
        // const {queryModel}=this.state;
        // queryModel.idCheck=id;
        // this.setState(state => {
        //     const checkboxDataTables = (new Map(): Map<string, boolean>);
        //     checkboxDataTables.set(id, !checkboxDataTables.get(id));// toggle
        //     return {checkboxDataTables};
        // });
        // this.refreshModel(queryModel);  
    };

    renderTable = () => {
        const { action,} = this.props;
        const {checkboxDataTables,editMode,tablas} = this.state;
        let checkbox = {
            data: checkboxDataTables,
            selectOne: this.toggleDocumentSelected
        }
       let table = renderTableName(headers, tablas, action, checkbox,editMode);
        return table;
    };

    renderColumName = () => {
        const {action} = this.props;
        const {checkboxDataTables,columName,queryModel} = this.state;
        let selected = {
            id:queryModel.idCheck|| 0,
            selectOne: this.columnSelected
        }
       let table = renderColumnsName(headers2, columName, action,selected);
        return table;
    };

    onchangeTableName = (event) =>{
        const {queryModel} = this.state;
        queryModel.tableName=event.nativeEvent.target.value;
        this.refreshModel(queryModel);
    }

    addTable = async () =>{
        const {showAlert, enableSpinner}= this.props
        const  {tablas,queryModel,columName} = this.state;
        let tableName=[];
        let tableNameData=[];
        let tableInfoResponse=[];
        tableName=tablas;
        tableNameData=columName;
        let name=queryModel.tableName;
        if(name!==''){
            let data={
                tableName:name
            }
            enableSpinner(true);
            tableInfoResponse = await apiClient.getColumnsNames(data);
            enableSpinner(false);
            if (tableInfoResponse.data.length === 0) {
                showAlert({type: 'info', message: 'No hay Información por mostrar'});
                return;
            }
            tableName.push({nombre:name});
            tableNameData.push(tableInfoResponse.data);
       }
        queryModel.tableName='';
        this.setState({
            tablas:tableName,
            columName:tableNameData
        })
        this.refreshModel(queryModel);
    }

    deleteTableName = () =>{
        const {checkboxDataTables,tablas,columName} = this.state;
        let tableName=[];
        let tableNameData=[]
        tableName=tablas;
        tableNameData=columName;
        tableName.map((register,index) => {
            if(checkboxDataTables.get(index)){
                tableName.splice(index,1);
                tableNameData.splice(index,1);
            }
        });
        this.setState({
            tablas:tableName,
            columName: tableNameData        
        });
    }

    renderQueryHeader = () => {
        const {queryModel} = this.state;
        return(
                <div className="tab-content" >
                    <QueryPreviewModal/>
                    <div className="card" style={{background: 'transparent'}}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <input className='form-control btn-outline-secondary dropdown-toggle listSerie hide-pc'
                                                style={{display: 'inline-flex'}} 
                                                autoComplete="off"
                                                type='search' aria-controls='dataTableTimbra'
                                                value={queryModel.tableName || ''}
                                                onChange={event => this.onchangeTableName(event)}
                                                onKeyPress={(ev) => {                         
                                                    if (ev.key === 'Enter') {
                                                      this.addTable();
                                                    }
                                                }}
                                                />
                                </div>
                            </div><br/>
                            <div className="row" >
                                <div className="col-md-12 col-sm-12">
                                {this.renderTable()}
                                </div>
                            </div>
                            <div className="row" >
                                <div className="col-md-12 col-sm-12">
                                    <button className="btn btn-outline-secondary btn-timbra-one"
                                    style={{ borderColor: "#A7A6A5"}}
                                    onClick={this.deleteTableName}>
                                        X
                                    </button>
                                    &nbsp;
                                    <button className="btn btn-outline-secondary btn-timbra-one"style={{ borderColor: "#A7A6A5"}}>
                                        {'>>'}
                                    </button>
                                </div>
                            </div>
                       
                        </div>
                    </div>
                </div>
          
                
        )
    };

    renderQueryBody = () => {
        return(
            
            <div className="tab-content" >
                <div className="card" style={{background: 'transparent'}}>
                    <div className="card-body">
                        <div className="row">
                             <div className="col-md-12 col-sm-12">
                                {this.renderColumName()}
                                </div>
                        </div>
                    </div>
                    <br/><br/><br/><br/>
                </div>
            </div>
            
          
        )
    };

    renderQueryFooter = () => {
        return(
            <div className="tab-content" >
                <div className="card" style={{background: 'transparent'}}>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <label>Seleccionar</label><br></br>
                                <textarea
                                type="text"
                                className=" form-control btn-outline-secondary"
                                id="txtComments"
                                rows="2"
                                cols="100"
                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                />
                            </div>     
                        </div>    
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <label>Desde</label><br></br>
                                <textarea
                                type="text"
                                className=" form-control btn-outline-secondary"
                                id="txtComments"
                                rows="2"
                                cols="100"
                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                />
                            </div>     
                        </div>  
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <label>Donde</label><br></br>
                                <textarea
                                type="text"
                                className=" form-control btn-outline-secondary"
                                id="txtComments"
                                rows="2"
                                cols="100"
                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                />
                            </div>     
                        </div>  
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <label>Clasificar por</label><br></br>
                                <textarea
                                type="text"
                                className=" form-control btn-outline-secondary"
                                id="txtComments"
                                rows="2"
                                cols="100"
                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                />
                            </div>     
                        </div>  
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <label>Agrupar por</label><br></br>
                                <textarea
                                type="text"
                                className=" form-control btn-outline-secondary"
                                id="txtComments"
                                rows="2"
                                cols="100"
                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                />
                            </div>     
                        </div>   
                    </div>   
                    <br/><br/><br/>                             
                </div>
            </div>
        )
    };

    render() {
       
        return (
            <div className="modal fade bd-example-modal-lg bgtransparent" id="queryModal" style={{zIndex:91}} role="dialog"
             aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-xl " role="document">
                    <div className="modal-content">
                    
                        <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                            <h4 className="modal-title" id="modal-basic-title ">Generador de Consultas</h4>
                            <button type="button" className="close" onClick={this.closeQuery}  aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row">
                                        <div className="col-md-2">{this.renderQueryHeader()}</div>
                                        <div className="col-md-4">{this.renderQueryBody()}</div>
                                        <div className="col-md-6">{this.renderQueryFooter()}</div>
                                </div>
                            </div>
                        </div>
                        <br/>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white"  onClick={this.ShowPreview} >Ejecutar</button>
                
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeQuery} >Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CreateQueryModal;